// Libs
import React, { ReactElement } from 'react';
import { Icon, Stack, Typography } from 'ui-components';
// App
import { AccountMenuUserInfoProps } from './account-menu-user-info-props.interface';
import { formatUserName } from 'app-shared/lib/utils';

const AccountMenuUserInfo = (props: AccountMenuUserInfoProps): ReactElement => {
  const { user } = props;

  const userName = formatUserName(user?.firstName, user?.lastName);
  const hasUserName = Boolean(user?.firstName || user?.lastName);

  return (
    <Stack px={3}>
      <Stack direction="row" alignItems="center" spacing={1.5}>
        <Icon name="user" />
        <Stack>
          {hasUserName && (
            <Typography
              variant="body2"
              component="div"
              fontWeight="600"
              maxWidth={172}
              textOverflow="ellipsis"
              overflow="hidden"
            >
              {userName}
            </Typography>
          )}
          {user?.email && (
            <Typography
              variant="body2"
              component="div"
              fontWeight="400"
              maxWidth={172}
              textOverflow="ellipsis"
              overflow="hidden"
            >
              {user?.email}
            </Typography>
          )}
        </Stack>
      </Stack>
    </Stack>
  );
};

export default AccountMenuUserInfo;
